import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as Actions from './actions';

const State = Record({
    likeMap: {},
});

const setLiking = (state, id, liking) =>
    state.merge({
        likeMap: {
            ...state.likeMap,
            [id]: liking,
        },
    });

export default handleActions(
    {
        [Actions.likeComment.type]: (state, {payload}) => setLiking(state, payload.commentId, !payload.liked),
        [Actions.likeCommentFailed.type]: (state, {payload}) => setLiking(state, payload.commentId, undefined),
        [Actions.likeActivity.type]: (state, {payload}) => setLiking(state, payload.activityId, !payload.liked),
        [Actions.likeActivityFailed.type]: (state, {payload}) => setLiking(state, payload.activityId, undefined),
        [Actions.clearLikeMap.type]: (state, {payload}) => setLiking(state, payload.id, undefined),
    },
    new State(),
);
